import React from 'react'

import { CardTemplate } from '../../../../components/CardTemplate'
import { PanelContainer } from '../../../../components/Panel'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { useConfigContext } from '../../../ui-config/context'
import { useInvoiceById } from '../../data'

type Props = {
  invoiceId: string
}

export const Header: React.FC<Props> = ({ invoiceId }) => {
  const { uiConfig: config } = useConfigContext()
  const { data: invoice, isLoading } = useInvoiceById(invoiceId)

  return (
    <PanelContainer
      header={getConfigTranslation(config.invoice.header.title)}
      id="invoice-header"
      visible={config.invoice.header.enabled}
    >
      <div className="grid">
        {/* buyer */}
        <CardTemplate
          title={getConfigTranslation(
            config.invoice.header.buyerInformation.title,
          )}
          data={invoice?.Payload.BuyerInformation}
          config={config.invoice.header.buyerInformation}
          isLoading={isLoading}
        />

        {/* seller */}
        <CardTemplate
          title={getConfigTranslation(
            config.invoice.header.sellerInformation.title,
          )}
          data={invoice?.Payload.SellerInformation}
          config={config.invoice.header.sellerInformation}
          isLoading={isLoading}
        />

        {/* billing */}
        <CardTemplate
          title={getConfigTranslation(
            config.invoice.header.billingInformation?.title,
          )}
          data={invoice?.Payload.BillingInformation}
          config={config.invoice.header.billingInformation}
          isLoading={isLoading}
        />

        {/* shipping */}
        <CardTemplate
          title={getConfigTranslation(
            config.invoice.header.shippingInformation?.title,
          )}
          data={invoice?.Payload.ShippingInformation}
          config={config.invoice.header.shippingInformation}
          isLoading={isLoading}
        />
      </div>
    </PanelContainer>
  )
}
